import axiosInstance from "./AxiosConfig";

class Package {
  async CreatePackage(data) {
    
    try {
      const response = await axiosInstance.post("/package/create", data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetAllPackage() {
    try {
      const response = await axiosInstance.get("/package/get");
      console.log("response", response);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetPackageById(id) {
    try {
      const response = await axiosInstance.get(`/package/getbyid/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdatePackageById(id, data) {
    try {
      const response = await axiosInstance.put(`/package/update/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeletePackageById(id) {
    try {
      const response = await axiosInstance.delete(`/package/delete/${id}`);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new Package();
